import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-database-migration',
  templateUrl: './database-migration.component.html',
  styleUrls: ['./database-migration.component.scss']
})
export class DatabaseMigrationComponent implements OnInit {
[x: string]: any;
  logoImg=`../../../assets/imgs/logo/se2in_logo_fullwhite.png`;
  page='';
  pricingLink=''
  constructor() { }

  ngOnInit(): void {
    let fullType = window.location.href.split('/')
    let type = fullType[3]
    this.page = type
    if(this.page =='database-migration'){
      this.pricingLink = 'pricing-plan/migration'
    }
  }

  ngAfterViewInit(): void {
    const triggerPoint = 80;
    const updateLogoForViewport = () => {
      if(window.innerWidth<777 || document.body.clientWidth<777 || window.innerWidth<992 && window.innerWidth>900 || window.innerWidth>1585){
        this.logoImg = `../../../assets/imgs/logo/se2in_logo.png`;
      }else{
        this.logoImg = `../../../assets/imgs/logo/se2in_logo_fullwhite.png`;
      }
    };

    updateLogoForViewport();
    window.addEventListener("resize", updateLogoForViewport);
    window.addEventListener("scroll", () => {
      const header = document.getElementById("main-header");
      const yOffset = window.scrollY;
      if (!header) {
        return;
      }
      if (yOffset >= triggerPoint) {
        header.classList.add("menu-sticky", "animated", "slideInDown", "slideWhite");
        this.logoImg = `../../../assets/imgs/logo/se2in_logo_fullwhite.png`;
      } else {
        header.classList.remove("menu-sticky", "animated", "slideInDown", "slideWhite");
        updateLogoForViewport();
      }
    });
  }

}
